import { Link } from "react-router-dom";

export default function ProductLink({
  product,
  source,
  imageHeight = "h-40",
  className = "",
}) {
  const formattedName =
    product.name?.charAt(0).toUpperCase() +
    product.name?.slice(1).toLowerCase();

  const price = parseFloat(
    product.variations?.[0]?.purchase_price || 0
  ).toLocaleString();

  return (
    <Link
      to={`/boutique/produit/${product.product_id}`}
      state={source === "pieces" ? { product, source } : null}
      className={`text-inherit ${className} py-4`}
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <h3 className="font-bold text-gray-800 text-start truncate  line-clamp-2 uppercase mb-2">
        {formattedName}
      </h3>

      {product.image_url ? (
        <img
          src={product.image_url}
          alt={product.name}
          className={`w-full ${imageHeight} object-contain mb-3`}
        />
      ) : (
        <div
          className={`w-full ${imageHeight} bg-gray-100 flex items-center justify-center text-blue-400 mb-3`}
        >
          <i className="fas fa-image fa-lg"></i>
        </div>
      )}

      <div className="my-5 font-semibold text-gray-700">
        A partir de <span className="text-orange-400">{price} FCFA </span>
        {source === "pieces" ? "" : "HT*"}
      </div>
    </Link>
  );
}
